import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, vModelCheckbox as _vModelCheckbox } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "clearfix" };
const _hoisted_3 = { class: "clearfix" };
const _hoisted_4 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_5 = { class: "input-group top_search" };
const _hoisted_6 = { class: "input-group-btn" };
const _hoisted_7 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_8 = { class: "checkbox-wrapper" };
const _hoisted_9 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_10 = { class: "float-end float-start-sm" };
const _hoisted_11 = { class: "col-xs-12 col-sm-12" };
const _hoisted_12 = { class: "card bg-white data-grid company-detail-grid detached" };
const _hoisted_13 = { class: "table table-hover small bottom0 pw100" };
const _hoisted_14 = { class: "text-center hidden-sm" };
const _hoisted_15 = ["onClick"];
const _hoisted_16 = ["title"];
const _hoisted_17 = { key: 0 };
const _hoisted_18 = { class: "data-grid-footer clearfix detached pw100" };
const _hoisted_19 = { class: "clearfix" };
const _hoisted_20 = { class: "col-sm-12 col-xs-12 col-md-12 bottom10" };
const _hoisted_21 = { class: "invalid-feedback" };
const _hoisted_22 = { class: "clearfix" };
const _hoisted_23 = { class: "col-sm-12 col-xs-12 col-md-12 bottom10" };
const _hoisted_24 = { key: 0 };
const _hoisted_25 = { class: "d-flex justify-content-between" };
const _hoisted_26 = { class: "d-flex" };
const _hoisted_27 = ["disabled"];
const _hoisted_28 = ["disabled"];
const _hoisted_29 = {
    class: "list-filter",
    style: { "height": "450px", "overflow-x": "auto", "border": "1px solid black", "background-color": "whitesmoke" }
};
const _hoisted_30 = { class: "list-options" };
const _hoisted_31 = ["onClick"];
const _hoisted_32 = { style: { "font": "700", "font-size": "16px" } };
const _hoisted_33 = { class: "float-end float-start-sm" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_button = _resolveComponent("b-button");
    const _component_SortableColumnComponent = _resolveComponent("SortableColumnComponent");
    const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
    const _component_b_dropdown_divider = _resolveComponent("b-dropdown-divider");
    const _component_b_dropdown = _resolveComponent("b-dropdown");
    const _component_b_pagination = _resolveComponent("b-pagination");
    const _component_b_container = _resolveComponent("b-container");
    const _component_b_modal = _resolveComponent("b-modal");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_b_form_input, {
                            type: "text",
                            modelValue: _ctx.query.keywords,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.query.keywords) = $event)),
                            modelModifiers: { trim: true },
                            placeholder: "Search for...",
                            onKeyup: _withKeys(_ctx.search, ["enter"]),
                            required: ""
                        }, null, 8 /* PROPS */, ["modelValue", "onKeyup"]),
                        _cache[12] || (_cache[12] = _createTextVNode()),
                        _createElementVNode("span", _hoisted_6, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-default",
                                onClick: _cache[1] || (_cache[1] =
                                    //@ts-ignore
                                    (...args) => (_ctx.search && _ctx.search(...args)))
                            }, [...(_cache[11] || (_cache[11] = [
                                    _createElementVNode("i", { class: "fa fa-search" }, null, -1 /* CACHED */)
                                ]))])
                        ])
                    ])
                ]),
                _cache[15] || (_cache[15] = _createTextVNode()),
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_b_form_checkbox, {
                            id: "includeArchivedContacts",
                            modelValue: _ctx.query.includeDeleted,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.query.includeDeleted) = $event)),
                            size: "lg"
                        }, {
                            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                    _createTextVNode("\r\n\t\t\t\t\t\t\tShow archived\r\n\t\t\t\t\t\t", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                    ])
                ]),
                _cache[16] || (_cache[16] = _createTextVNode()),
                _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_b_button, {
                            variant: "primary",
                            onClick: _ctx.add
                        }, {
                            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                    _createElementVNode("span", { class: "fa fa-plus" }, null, -1 /* CACHED */),
                                    _createElementVNode("span", { class: "hidden-xs" }, " Add Contact Group", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"])
                    ])
                ])
            ]),
            _cache[33] || (_cache[33] = _createTextVNode()),
            _withDirectives(_createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("table", _hoisted_13, [
                        _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                _cache[17] || (_cache[17] = _createElementVNode("th", { class: "text-center hidden-sm w40 no-min-width" }, null, -1 /* CACHED */)),
                                _cache[18] || (_cache[18] = _createTextVNode()),
                                _createElementVNode("th", null, [
                                    _createVNode(_component_SortableColumnComponent, {
                                        sorter: _ctx.sorter,
                                        column: { fieldName: 'Description', title: 'Description' }
                                    }, null, 8 /* PROPS */, ["sorter"])
                                ]),
                                _cache[19] || (_cache[19] = _createTextVNode()),
                                _cache[20] || (_cache[20] = _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\tContacts\r\n\t\t\t\t\t\t\t\t", -1 /* CACHED */))
                            ])
                        ]),
                        _cache[30] || (_cache[30] = _createTextVNode()),
                        _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.records, (item) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                    class: _normalizeClass({ 'deleted': item.whenDeleted })
                                }, [
                                    _createElementVNode("td", _hoisted_14, [
                                        _createVNode(_component_b_dropdown, {
                                            variant: "outline-secondary dots",
                                            size: "sm",
                                            onClick: ($event) => (_ctx.edit(item))
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_b_dropdown_item, {
                                                    onClick: ($event) => (_ctx.edit(item))
                                                }, {
                                                    default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                                            _createElementVNode("span", { class: "fa fa-pencil" }, null, -1 /* CACHED */),
                                                            _createTextVNode(" Edit\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                        ]))]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["onClick"]),
                                                _cache[24] || (_cache[24] = _createTextVNode()),
                                                _createVNode(_component_b_dropdown_divider),
                                                _cache[25] || (_cache[25] = _createTextVNode()),
                                                _withDirectives(_createVNode(_component_b_dropdown_item, {
                                                    onClick: ($event) => (_ctx.archive(item))
                                                }, {
                                                    default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                                            _createElementVNode("span", { class: "fa fa-trash" }, null, -1 /* CACHED */),
                                                            _createTextVNode(" Archive\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                        ]))]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["onClick"]), [
                                                    [_vShow, !item.whenDeleted]
                                                ]),
                                                _cache[26] || (_cache[26] = _createTextVNode()),
                                                _withDirectives(_createVNode(_component_b_dropdown_item, {
                                                    onClick: ($event) => (_ctx.restore(item))
                                                }, {
                                                    default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                                            _createElementVNode("span", { class: "fa fa-refresh" }, null, -1 /* CACHED */),
                                                            _createTextVNode(" Restore\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                        ]))]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["onClick"]), [
                                                    [_vShow, item.whenDeleted]
                                                ])
                                            ]),
                                            _: 2 /* DYNAMIC */
                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                    ]),
                                    _cache[27] || (_cache[27] = _createTextVNode()),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            class: "blue pointer",
                                            onClick: ($event) => (_ctx.edit(item))
                                        }, _toDisplayString(item.description), 9 /* TEXT, PROPS */, _hoisted_15)
                                    ]),
                                    _cache[28] || (_cache[28] = _createTextVNode()),
                                    _createElementVNode("td", {
                                        class: "large-text-ellipsis",
                                        title: _ctx.getContactsNamesTitle(item)
                                    }, _toDisplayString(_ctx.getContactsNames(item)), 9 /* TEXT, PROPS */, _hoisted_16)
                                ], 2 /* CLASS */));
                            }), 256 /* UNKEYED_FRAGMENT */))
                        ]),
                        _cache[31] || (_cache[31] = _createTextVNode()),
                        _createElementVNode("tfoot", null, [
                            (_ctx.noData)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [...(_cache[29] || (_cache[29] = [
                                        _createElementVNode("td", {
                                            class: "text-center",
                                            colspan: "5"
                                        }, [
                                            _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t")
                                        ], -1 /* CACHED */)
                                    ]))]))
                                : _createCommentVNode("v-if", true)
                        ])
                    ])
                ]),
                _cache[32] || (_cache[32] = _createTextVNode()),
                _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_b_pagination, {
                        class: "float-end",
                        modelValue: _ctx.query.pageNo,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.query.pageNo) = $event)),
                        "per-page": _ctx.query.pageSize,
                        "total-rows": _ctx.data.recordCount,
                        "hide-ellipsis": true,
                        disabled: _ctx.working
                    }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                ])
            ], 512 /* NEED_PATCH */), [
                [_vShow, _ctx.searchAttempted]
            ])
        ]),
        _cache[55] || (_cache[55] = _createTextVNode()),
        _createVNode(_component_b_modal, {
            class: "modal-form-lg",
            id: "contact_group_popup",
            modelValue: _ctx.editingContactGroup,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.editingContactGroup) = $event)),
            "header-bg-variant": "normal",
            size: "md"
        }, {
            title: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                    _createTextVNode("\r\n\t\t\t\tContact Group\r\n\t\t\t", -1 /* CACHED */)
                ]))]),
            footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_33, [
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "primary",
                        onClick: _cache[7] || (_cache[7] = ($event) => (_ctx.save(_ctx.contactGroup)))
                    }, {
                        default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
                                _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* CACHED */),
                                _createTextVNode(" Save\r\n\t\t\t\t\t", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }),
                    _cache[50] || (_cache[50] = _createTextVNode()),
                    _withDirectives(_createVNode(_component_b_button, {
                        type: "button",
                        variant: "danger",
                        onClick: _cache[8] || (_cache[8] = ($event) => (_ctx.archive(_ctx.contactGroup)))
                    }, {
                        default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                                _createElementVNode("i", { class: "fa fa-trash" }, null, -1 /* CACHED */),
                                _createTextVNode(" Archive\r\n\t\t\t\t\t", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 512 /* NEED_PATCH */), [
                        [_vShow, _ctx.contactGroup.contactGroupId && !_ctx.contactGroup.whenDeleted]
                    ]),
                    _cache[51] || (_cache[51] = _createTextVNode()),
                    _withDirectives(_createVNode(_component_b_button, {
                        type: "button",
                        variant: "warning",
                        onClick: _cache[9] || (_cache[9] = ($event) => (_ctx.restore(_ctx.contactGroup)))
                    }, {
                        default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                                _createElementVNode("i", { class: "fa fa-refresh" }, null, -1 /* CACHED */),
                                _createTextVNode(" Restore\r\n\t\t\t\t\t", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 512 /* NEED_PATCH */), [
                        [_vShow, _ctx.contactGroup.contactGroupId && _ctx.contactGroup.whenDeleted]
                    ]),
                    _cache[52] || (_cache[52] = _createTextVNode()),
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "secondary",
                        onClick: _ctx.cancel
                    }, {
                        default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                                _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */),
                                _createTextVNode(" Close\r\n\t\t\t\t\t", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])
                ])
            ]),
            default: _withCtx(() => [
                _cache[53] || (_cache[53] = _createTextVNode()),
                _createVNode(_component_b_container, { clearfix: "" }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                                _cache[35] || (_cache[35] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\tDescription *\r\n\t\t\t\t\t\t", -1 /* CACHED */)),
                                _cache[36] || (_cache[36] = _createTextVNode()),
                                _createVNode(_component_b_form_input, _mergeProps(_ctx.descriptionVal, {
                                    type: "text",
                                    modelValue: _ctx.contactGroup.description,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.contactGroup.description) = $event)),
                                    modelModifiers: { trim: true },
                                    name: "description",
                                    class: { 'is-invalid': _ctx.errors && _ctx.errors.description },
                                    maxlength: "250"
                                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                _cache[37] || (_cache[37] = _createTextVNode()),
                                _withDirectives(_createElementVNode("div", _hoisted_21, "\r\n\t\t\t\t\t\t\t* Please enter a description\r\n\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                    [_vShow, _ctx.errors && _ctx.errors.description]
                                ])
                            ])
                        ]),
                        _cache[45] || (_cache[45] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                                (!_ctx.loadingContacts)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                        _createElementVNode("div", _hoisted_25, [
                                            _cache[40] || (_cache[40] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\tContacts\r\n\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                            _cache[41] || (_cache[41] = _createTextVNode()),
                                            _createElementVNode("div", _hoisted_26, [
                                                _createElementVNode("label", null, "Selected: " + _toDisplayString(_ctx.selectedContactCount()), 1 /* TEXT */),
                                                _cache[38] || (_cache[38] = _createTextVNode()),
                                                _withDirectives(_createElementVNode("input", {
                                                    class: "form-check-input ms-3",
                                                    style: { "margin-top": "2px" },
                                                    type: "checkbox",
                                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.showOnlySelected) = $event)),
                                                    disabled: _ctx.selectedContactCount() == 0
                                                }, null, 8 /* PROPS */, _hoisted_27), [
                                                    [_vModelCheckbox, _ctx.showOnlySelected]
                                                ]),
                                                _cache[39] || (_cache[39] = _createTextVNode()),
                                                _createElementVNode("label", {
                                                    class: "form-check-label",
                                                    disabled: _ctx.selectedContactCount() == 0
                                                }, " Show only selected", 8 /* PROPS */, _hoisted_28)
                                            ])
                                        ]),
                                        _cache[43] || (_cache[43] = _createTextVNode()),
                                        _createVNode(_component_b_form_input, {
                                            modelValue: _ctx.contactsFilter,
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.contactsFilter) = $event)),
                                            modelModifiers: { trim: true },
                                            placeholder: "Search for..."
                                        }, null, 8 /* PROPS */, ["modelValue"]),
                                        _cache[44] || (_cache[44] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_29, [
                                            _createElementVNode("div", _hoisted_30, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contactsFiltered, (item) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        class: _normalizeClass(['list-option', _ctx.isContactSelected(item) ? 'selected-option' : '']),
                                                        onClick: ($event) => (_ctx.selectContact(item)),
                                                        style: { "text-align": "left", "padding": "5px" }
                                                    }, [
                                                        _createElementVNode("div", null, [
                                                            _createElementVNode("span", _hoisted_32, _toDisplayString(item.firstName) + " " + _toDisplayString(item.lastName), 1 /* TEXT */)
                                                        ]),
                                                        _cache[42] || (_cache[42] = _createTextVNode()),
                                                        _createElementVNode("div", null, [
                                                            _createElementVNode("span", null, _toDisplayString(item.emailAddress), 1 /* TEXT */)
                                                        ])
                                                    ], 10 /* CLASS, PROPS */, _hoisted_31));
                                                }), 256 /* UNKEYED_FRAGMENT */))
                                            ])
                                        ])
                                    ]))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ])
                    ]),
                    _: 1 /* STABLE */
                }),
                _cache[54] || (_cache[54] = _createTextVNode())
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"])
    ]));
}
